import { render, staticRenderFns } from "./skmx.vue?vue&type=template&id=3cf10b68&scoped=true"
import script from "./skmx.vue?vue&type=script&lang=js"
export * from "./skmx.vue?vue&type=script&lang=js"
import style0 from "./skmx.vue?vue&type=style&index=0&id=3cf10b68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf10b68",
  null
  
)

export default component.exports